// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"54ed8993","453":"d93acb68","517":"8953977b","659":"68f6fa69","701":"55e50937"}[chunkId] + ".chunk.js";
};